import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const getCheckboxIconWidth = (theme: Theme) => theme.spacing[24];
export const getCheckboxIconSpacing = (theme: Theme) => theme.presentation.choice.iconGap;

export const root = (theme: Theme) => css`
  width: ${getCheckboxIconWidth(theme)};
  height: ${getCheckboxIconWidth(theme)};
  border-radius: ${theme.borderRadius.sm};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${theme.palette.background.main};
  border: 2px solid ${theme.palette.ghost.main};
`;

export const uncheckedDisabled = (theme: Theme) => css`
  background: ${theme.presentation.selection.disabled};
  border-color: ${theme.presentation.selection.disabledBorder};
`;

export const uncheckedError = (theme: Theme) => css`
  border-color: ${theme.palette.error.main};
`;

export const checked = (theme: Theme) => css`
  background: ${theme.presentation.selection.active};
  border: none;

  svg {
    // The tick stays light in both modes -- primary.reversedContrast is dark
    // on the dark theme, which would lose it against the accent fill.
    fill: ${theme.presentation.selection.onActive};
  }
`;

export const checkedDisabled = (theme: Theme) => css`
  background: ${theme.presentation.selection.disabled};
  border: none;

  svg {
    fill: ${theme.palette.disabled.accent};
  }
`;
